// Hooks
import useAggregationExtended from "@Layouts/components/Tables/DataSmartTable/aggregation/Aggregation";
import { useGridApiRef } from "@mui/x-data-grid-premium";
// Components
import TechnicianDataTable from "./TechnicianDataTable";
// Types
import { IRepairOrder, ITechnicianFlaggedTimeBase } from "@/DataPages/types/technicianFlaggedTime/model";
import { ITFTFooterModel } from "@DataPages/components/ServiceOperations/Tabs/TechnicianFlaggedTime/interfaces";

export interface IPerformanceTableProps {
	data: IRepairOrder[];
	hasNextPage: boolean;
	technicianPerformance: ITechnicianFlaggedTimeBase | null;
}

export const PerformanceTable = (props: Readonly<IPerformanceTableProps>) => {
	const { data, hasNextPage, technicianPerformance } = props;
	const apiRef = useGridApiRef();

	const aggregations = useAggregationExtended({
		selectedSum: {},
		selectedMedian: {},
	});

	const footerModels: ITFTFooterModel = {
		employeeName: "technicianUniqueCount",
		operationCode: "technicianUniqueCount",
		reason: "technicianUniqueCount",
		actualTime: "technicianCustomSum",
		bookedTime: "technicianCustomSum",
		jobStatus: "technicianUniqueCount",
		rate: "technicianCustomRate",
		extended: "technicianCustomSum",
		payrollStatus: "technicianUniqueCount",
	};

	return (
		<TechnicianDataTable
			hasNextPage={hasNextPage}
			apiRef={apiRef}
			title="Flagged Time Performance"
			rows={data}
			aggregations={aggregations}
			footerModels={footerModels}
			technicianPerformance={technicianPerformance}
		/>
	);
};
